import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { Typography } from '@mui/material'
import { useForm, FormProvider } from "react-hook-form";

import { notificationActions, fileActions, addTitleLegoCurrent } from '../../store/actions'
import { InputField, CustomLoadingOverlay, GenericContainer, Buttons } from '../../components'
import { coreFunctions } from '../../utils'
import { useTranslation } from 'react-i18next';

export default function OTPEditDataComponent(props) {
  const formMethods = useForm({ mode: "onChange" });
  const { control, handleSubmit, register, formState } = useForm({ mode: "onBlur" });

  const [loadView, setLoadView] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()

  //Estados de componente
  const [dataIsUpdated, setDataStatus] = useState(false)
  const [fileId, setFileId] = useState(0);
  const [fileInfoActive, setFileInfoActive] = useState(false)

  //Redux hooks
  const file = useSelector(state => state.FileInfo)
  const updateResponse = useSelector(state => state.UpdateMetadata)
  const dispatch = useDispatch()
  const { t } = useTranslation();
  const flujoUser = sessionStorage.getItem('FlujoUser')

  useEffect(() => {
    dispatch(addTitleLegoCurrent("Edición de datos OTP"))
    console.log("location.state: ", location.state)
    setFileId(location.state.folioId)
  }, [])

  useEffect(() => {
    // setLoadView(updateResponse.loading)
    if (updateResponse.items != undefined && dataIsUpdated) {
      setFileInfoActive(true)
      setDataStatus(false)
      dispatch(fileActions.GetFileInfo(fileId))
    } else if (updateResponse.error != undefined && dataIsUpdated) {
      setDataStatus(false)
      setLoadView(false)
      alert(updateResponse.error)
    }
  }, [updateResponse])

  useEffect(() => {
    if (file.items != undefined && fileInfoActive) {
      //Enviar a siguiente componente definido en el nucleo
      setLoadView(false)
      let nextStage = file.items.Stage
      let stageName = nextStage.Name
      let stageId = nextStage.Id
      let folioId = file.items.Id
      let stage = file.items
      let nextComponent = "OTPComponent"
      coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
    }
    if (file.error != undefined && fileInfoActive) {
      alert(file.error)
      setLoadView(false)
    }
  }, [file])

  //Método controlador de reenvió de pin o edición de datos
  let handleSend = (formData) => {
    console.log("formData......: ", formData)

    let request = {
      ContinueWorkFlow: false,
      Metadata: [
        {
          GroupName: "Datos Personales",
          Name: "Correo electrónico",
          Value: formData["txtEmail"]
        },
        {
          GroupName: "Datos Personales",
          Name: "Teléfono",
          Value: formData["txtPhone"]
        }
      ],
      ObjectId: fileId
    }

    console.log("...request......: ", request)
    setDataStatus(true)
    setLoadView(true)
    dispatch(notificationActions.UpdateMetadata(request))
  }

  let handleCancel = () => {
    let nextStage = location.state.stage
    let stageName = nextStage.Name
    let stageId = nextStage.Id
    let folioId = fileId
    let stage = location.state
    let nextComponent = "OTPComponent"
    coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
  }

  const phoneRegular = () => {
    switch (flujoUser) {
      case 'Contratación Argentina':
        return "ar"
      case 'Contratación ML Chile Masivo':
        return "cl"
      case 'Contratación Colombia Estándar':
        return "co"
      case 'Contratación ML Chile Estándar':
        return "cl"
      case 'Contratación Colombia Masivo':
        return "co"
      case 'Contratación Expand México':
        return "mx"
      case 'Contratación ML Chile Seguros':
        return "cl"
      case 'Contratación México WSM':
        return "mx"
      case 'Contratación Uruguay':
        return "uy"
      default:
        return 'mx'
    }
  }

  const validatePhoneNumber = (number, minLength) => {
    return number?.replace(/\D/g, '').length >= minLength || 'Número de teléfono incompleto'
  }

  //Comienza interfaz
  return (<GenericContainer>
    <FormProvider {...formMethods} >
      <Typography variant="h6" gutterBottom >
        Verificación de datos
      </Typography>
      <Typography variant="subtitle1"
        gutterBottom
      >Verifica que los datos sean correctos, de lo contrario te sugerimos actualizarlos para enviar un nuevo código de acceso.</Typography>
      <InputField
        inputType="phone"
        phoneRegular={phoneRegular()}
        control={control}
        register={register}
        name='txtPhone'
        label='Teléfono'
        validations={{ required: true, validate: (e)=> validatePhoneNumber(e, 12) }}
        required={true}
        error={!!formState.errors['txtPhone']}
        helperText={formState.errors['txtPhone']?.message}
      />
      <InputField
        inputType="email"
        control={control}
        register={register}
        name='txtEmail'
        label='Correo electrónico'
        validations={{ required: true }}
        required={true}
        error={!!formState.errors['txtEmail']}
        helperText={formState.errors['txtEmail']?.message}
      />
      <Buttons
        ConfirmButtonText={t("general_accept")}
        onClickConfirm={handleSubmit(handleSend)}
        CancelButtonText={t("general_cancel")}
        onClickCancel={handleCancel} />

      {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
    </FormProvider>
  </GenericContainer>)
}
